import {create} from 'zustand';

interface SoundState {
  audio: HTMLAudioElement | null;
  isMuted: boolean;
  isPlaying: boolean;
  createAudio: (src: string) => void;
  toggleMute: () => void;
}

export const useAudioStore = create<SoundState>((set, get) => ({
  audio: null,
  isMuted: true,
  isPlaying: false,
  createAudio: (src: string) => {
    const audio = new Audio(src);
    audio.loop = true;
    audio.volume = 0.5;
    audio.muted = true;
    audio.addEventListener('play', () => {
      set({isPlaying: true});
    });
    audio.addEventListener('pause', () => {
      set({isPlaying: false});
    });
    audio.addEventListener('ended', () => {
      set({isPlaying: false});
    });

    set({audio, isPlaying: false});
  },
  toggleMute: () => {
    const {audio, isMuted} = get();
    if (!audio) return;

    const newMuted = !isMuted;
    set({isMuted: newMuted});
    audio.muted = newMuted;

    if (!newMuted) {
      audio.play().catch((e) => {
        console.warn('재생 실패:', e);
      });
    } else {
      audio.pause(); // 이 줄이 핵심!
    }
  },
}));
